import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { NotificationService } from '../services/notification.service';
import { OxErrorResponse } from '../interfaces';
import { hasIn } from 'lodash';

interface OxHttpErrorResponse extends HttpErrorResponse {
  error: OxErrorResponse;
}
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const ignoredErrorStatuses = [404];
    const ignoredErrorCodes = [
      6714, // Invalid email format or domain
      36115,
      14652,
    ];
    // Hide notification message if these 400 Bad Request error codes are returned
    const badRequestErrorCodes = [
      6715, // Invalid email format (suggested email)
    ];

    return next.handle(req).pipe(
      catchError((error: OxHttpErrorResponse) => {
        if (
          (!ignoredErrorStatuses.includes(error.status) &&
            !badRequestErrorCodes.includes(error.error.code)) ||
          (ignoredErrorStatuses.includes(error.status) &&
            hasIn(error.error, 'code') &&
            ignoredErrorCodes.includes(error.error.code))
        ) {
          const notification = this.injector.get(NotificationService);
          notification.errorHandler(error.error);
        }

        return throwError(error);
      })
    );
  }
}
